import { render, staticRenderFns } from "./DetailedArticle.vue?vue&type=template&id=06153ee2&"
import script from "./DetailedArticle.vue?vue&type=script&lang=js&"
export * from "./DetailedArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports